import "./Aprimo/aprimo-tracking";

document.addEventListener('DOMContentLoaded', () => {
    const buttons = document.querySelectorAll('.hover-gradiend-effect');

    buttons.forEach(btn => {
        btn.addEventListener('touchstart', () => {
            btn.classList.add('touched');
        });

        btn.addEventListener('touchend', () => {
            setTimeout(() => {
                btn.classList.remove('touched');
            }, 150);
        });
    })
});